// extracted by css-extract-rspack-plugin
module.exports =  {"hris_initial_access_confirmation_modal":"InitialAccessConfirmation_hris_initial_access_confirmation_modal__Ja7_2"};